module.exports = __webpack_public_path__ + "static/img/10014 (3).650190b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10014 (3).webp
// module id = lqCx
// module chunks = 14